<!-- DAppCell组成的List，支持Title，通常有5个Cell -->

<template>
  <div v-if="dapps && dapps.length > 0" class="dapp-cell-list">
    <slot name="title"></slot>
    <div class="dapp-cell-list-content">
      <DAppCell v-for="dapp in dapps" :key="dapp.key"
                :dapp="dapp" :user-count="dapp.user1d || 0" :shadow="true"
                class="dapp-cell-list-item mb-2">
      </DAppCell>
    </div>
  </div>
</template>

<script>
  import DAppCell from './DAppCell'

  export default {
    name: 'DAppCellList',
    components: {DAppCell},
    props: ['dapps'],
  }
</script>

<style lang="scss" scoped>

  @import "../utils";

  .dapp-cell-list {
    padding: 10px 15px;
    background-color: #E4E4E4;
  }

</style>



// WEBPACK FOOTER //
// src/widgets/DAppCellList.vue